module.exports = __webpack_public_path__ + "static/media/raz-default.f588dbea.png";